import { useState, useEffect, useRef } from "react";
import MobileLayout from "../MobileLayout";
import { AppBar, Box, Button, Toolbar, makeStyles } from "@material-ui/core";
import breeferLogo from "../asset/logo/LOGO_ORANGE.svg";
import ReactPlayer from "react-player";
import { videoTracker } from "../lib/learningStats";
import { useNavigate } from "react-router";
import "./VideoScene.css";
import { useMediaQuery } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import breeferPlayButton from "../asset/icons/breeferPlayButton.png";
import breeferReplayButton from "../asset/icons/replay.png";
import breeferDisabledPlayButton from "../asset/icons/breeferDisabledPlayButton.png";
import { setDuration } from "../game/slice";
import { useTranslation } from "react-i18next";
import "../App.css";
import { RootState } from "../redux/store";
import analytics from "../analytics/track";
import { useBreefDetails } from "../game/gameService";

interface Question {
  question: string;
  options: string[];
  answer: number;
}
const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
    backgroundColor: "transparent",
    boxShadow: "none",
  },
  title: {
    flexGrow: 1,
    color: "black",
    textAlign: "center",
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
  },
  overlay: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 2,
    cursor: "pointer",
  },
  hidden: {
    display: "none",
  },
}));

export const VideoScene = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(max-width:1024px)");
  const [t, i18n] = useTranslation("global");
  // A video that cannot play must not stop the breef
  const [videoFailed, setVideoFailed] = useState(false);
  const dispatch = useDispatch();
  const classes = useStyles();
  const navigate = useNavigate();
  const videoUrl: any = sessionStorage.getItem("videoUrl");
  const userId: any = sessionStorage.getItem("InvitedUserId");
  const tenantId: any = sessionStorage.getItem("tenantId");
  const [isVideoEnded, setIsVideoEnded] = useState(false);
  const [isOverlayVisible, setIsOverlayVisible] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isTracked, setIsTracked] = useState(false);
  // After a reload the store is empty - the breef is fetched again from its id in sessionStorage
  const storeBreef = useSelector((state: RootState) => state.score.breefDetails);
  const breefDetails = useBreefDetails() || storeBreef;
  const questions: Question[] = breefDetails.questions;
  const videoContainerRef = useRef<HTMLDivElement>(null);
  const [isFullScreen, setIsFullScreen] = useState(false);
  useEffect(() => {
    if (!isTracked) {
      analytics.track("Video Page Viewed", {
        breef_id: breefDetails.id,
        tenant_id: tenantId,
        user_id: userId,
        number_of_qustions: questions.length,
        start_date: "",
        expiry_date: breefDetails.expiry,
        video_url: videoUrl,
        current_page: "video",
        game_name: breefDetails.gameId.gameName,
      });
      setIsTracked(true);
    }
  }, [isTracked]);

  const handleVideoEnd = () => {
    setIsVideoEnded(true);
    setIsOverlayVisible(true);
    setIsPlaying(false);
  };
  const userName = sessionStorage.getItem("firstName");
  const handlePlayButtonClick = () => {
    console.log("clicked");
    navigate("/quiz-info");
  };
  const handleDuration = (duration: number) => {
    sessionStorage.setItem("duration", duration.toString());
    dispatch(setDuration(duration));
  };
  const handleOverlayClick = () => {
    setIsOverlayVisible(false);
    setIsPlaying(true);
    setIsVideoEnded(false);
  };
  const handlePlay = () => {
    const videoElement = document.querySelector("video");

    if (videoElement) {
      if (videoElement.requestFullscreen) {
        videoElement.requestFullscreen();
      } else if ((videoElement as any).webkitEnterFullscreen) {
        (videoElement as any).webkitEnterFullscreen();
      }
      setIsFullScreen(true);
    }
  };

  const handlePause = () => {
    const videoElement = document.querySelector("video");

    if (document.fullscreenElement) {
      document.exitFullscreen().catch(err => console.error("Error exiting fullscreen:", err));
    } else if ((videoElement as any).webkitExitFullscreen) {
      (videoElement as any).webkitExitFullscreen();
    }

    setIsFullScreen(false);
  };


  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);
  return (
    <MobileLayout>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar>{/* <img src={breeferLogo} alt="logo" height="80 rem" /> */}</Toolbar>
      </AppBar>
      <div ref={videoContainerRef} style={{ marginBottom: "2.7%", display: "flex", justifyContent: "center" }}>
        <div className="video-container"
          style={{
            width: "100%",
            position: "relative",
          }}
        >
          <ReactPlayer
            className="react-player"
            style={{
              backgroundColor: "black",
              objectFit: isFullScreen ? "cover" : "contain",
              height: isFullScreen ? "100vh" : "64vh",
              width: "100%",
            }}
            url={videoUrl}
            width="100%"
            height={isFullScreen ? "100vh" : "64vh"}
            playing={isPlaying}
            loop={false}
            controls={true}
            onEnded={() => {
              videoTracker.ended();
              handleVideoEnd();
            }}
            onDuration={(duration: number) => {
              videoTracker.duration(duration);
              handleDuration(duration);
            }}
            onProgress={({ playedSeconds }: { playedSeconds: number }) => videoTracker.progress(playedSeconds)}
            onSeek={(seconds: number) => videoTracker.seek(seconds)}
            onPause={() => {
              setIsOverlayVisible(true);
              setIsPlaying(false);
              handlePause();
            }}
            onPlay={handlePlay}
            onError={() => setVideoFailed(true)}
            playsinline
          />
          {videoFailed && (
            <div style={{ position: "absolute", inset: 0, background: "rgba(255,255,255,0.95)", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "1rem", padding: "1.5rem", textAlign: "center", fontFamily: "Roboto, Arial, sans-serif" }}>
              <p style={{ margin: 0 }}>{t("video.failed")}</p>
              <span onClick={handleVideoEnd} style={{ color: "#EB6608", fontWeight: "bold", cursor: "pointer", fontSize: "1.1rem" }}>
                {t("video.continueToQuiz")}
              </span>
            </div>
          )}

          {isOverlayVisible && !isPlaying && (
            <div className={classes.overlay}>
              <img
                src={isVideoEnded ? breeferReplayButton : breeferPlayButton}
                alt={isVideoEnded ? "Afspil igen" : "Afspil videoen"}
                style={{ cursor: "pointer" }}
                height={"120px"}
                onClick={() => {
                  handleOverlayClick();
                  analytics.track(`${isPlaying ? "Play" : "Pause"} button clicked`, {
                    breef_id: breefDetails.id,
                    tenant_id: tenantId,
                    user_id: userId,
                    number_of_qustions: questions.length,
                    start_date: "",
                    expiry_date: breefDetails.expiry,
                    video_url: videoUrl,
                    current_page: "video",
                    game_name: breefDetails.gameId.gameName,
                  })
                }}
              />
            </div>
          )}
        </div>
      </div>
      <div style={{ margin: "2rem 1rem" }}>
        <div style={{ fontSize: "2rem", textAlign: "center" }}>
          {isVideoEnded ? (
            <div
              className="container"
              style={{
                color: "#EB6608",
                cursor: "pointer",
                zIndex: 3,
                textTransform: "none",
                lineHeight: "2rem",
                fontWeight: "400",
                textWrap: "pretty",
                wordBreak: "keep-all",
                overflowWrap: "break-word",
              } as React.CSSProperties}
              onClick={() => {
                handlePlayButtonClick();
                analytics.track("Video Next button clicked", {
                  breef_id: breefDetails.id,
                  tenant_id: tenantId,
                  user_id: userId,
                  number_of_qustions: questions.length,
                  start_date: "",
                  expiry_date: breefDetails.expiry,
                  video_url: videoUrl,
                  current_page: "video",
                  game_name: breefDetails.gameId.gameName,
                })
              }}
            >
              {t("video.clickHereToGoToQuiz1")}
              <div style={{marginTop: "0.5rem"}}>
                {t("video.clickHereToGoToQuiz2")}
              </div>

            </div>
          ) : (
            <div className="container" style={{ textAlign: "left", margin: "10% 13%" }}>
              <span style={{ color: "#EB6608", fontWeight: "900" }}>{t("video.title2")}</span>

              {t("video.title3")}
            </div>
          )}
        </div>
        {/* <div style={{ fontSize: "0.8rem", marginTop: "0.5rem", color: "#1C1B1F99", fontWeight: "700" }}>{t('video.txt')}</div> */}
      </div>
      {/* <Box style={{ position: 'absolute', bottom: '3rem', left: '50%', transform: 'translateX(-50%)' }}>
                {isVideoEnded ? (
                    <img src={breeferPlayButton} alt="Play Button" style={{ display: 'block', margin: '0 auto', cursor: 'pointer' }} onClick={handlePlayButtonClick} />
                ) : (
                    <img src={breeferDisabledPlayButton} alt="Disabled Play Button" style={{ display: 'block', margin: '0 auto' }} />
                )}
            </Box> */}
    </MobileLayout>
  );
};
